export default {

  data () {
    return {
      isLoading:false
    }
  },

  computed: {
    modalClass (){
      return {
        'modal-loading-state': this.isLoading,
        'modal-loading-height': true
      }
    }
  }
}
